<template>

	<header class="header-main">
		<a class="skip-to-main" href="#main-content">skip to main content</a>
		<UtilityNav :utilityNav="utilityNav"></UtilityNav>
		<SiteNavigation :siteNavigation="siteNavigation" :utilityNav="utilityNav"></SiteNavigation>
		<div class="header-alerts">
			<Alerts :Alerts="Alerts"></Alerts>
		</div>
	</header>
	
</template>

<script>

	import UtilityNav from './UtilityNav.vue';
    import SiteNavigation from './SiteNavigation.vue';
    import Alerts from './Alerts.vue';
	
	export default {
		name: 'Header',
		
		props: ['utilityNav', 'siteNavigation', 'Alerts'],
		
		components: {
			UtilityNav,
            SiteNavigation,
            Alerts
		}
	}
	
</script>